export default {"spinner-spin":"_8Df6nW_spinner-spin","sm":"_8Df6nW_sm","lg":"_8Df6nW_lg","spinner":"_8Df6nW_spinner","xl":"_8Df6nW_xl",}